import { Box, Tooltip } from '@mui/material';
import startCase from 'lodash/startCase';
import React from 'react';

import { ToolName } from '../Types/enums';
import { getToolIcon } from './Chat/ChatTools';

interface ToolIconsProps {
  tools: ToolName[];
  size?: number;
}

const ToolIcons = ({ tools, size = 24 }: ToolIconsProps) => (
  <Box display="flex" gap={1} my={1}>
    {tools.map((tool) => (
      <Tooltip title={startCase(tool)} placement="top" key={tool}>
        {getToolIcon(tool, { width: `${size}px`, height: `${size}px` })}
      </Tooltip>
    ))}
  </Box>
);

export default ToolIcons;
